import { api } from "./api";
import {
  TCheckUserPaymentTokenResponse,
  TGetTherapistServicesWithPricesResponse,
  TChargeTokenRequest,
  TChargeTokenResponse,
  TUpdateQuestionnaireScoreTotalAmountRequest,
  TUpdateQuestionnaireScoreTotalAmountResponse,
  TPaymentTypesResponse,
  TQuestionnaireScoreStatusesResponse,
} from "../types/payment.types";

export const paymentsApi = api.injectEndpoints({
  endpoints: (build) => ({
    checkUserPaymentToken: build.query<
      TCheckUserPaymentTokenResponse,
      string
    >({
      query: (userGuid) => ({
        url: `/Payments/CheckUserPaymentToken/${userGuid}`,
        method: "GET",
      }),
      providesTags: (result, error, userGuid) => [
        { type: "PaymentToken", id: userGuid },
      ],
    }),
    getTherapistServicesWithPrices: build.query<
      TGetTherapistServicesWithPricesResponse,
      void
    >({
      query: () => ({
        url: `/Payments/GetTherapistServicesWithPrices`,
        method: "GET",
      }),
    }),

    chargeToken: build.mutation<
      TChargeTokenResponse,
      TChargeTokenRequest
    >({
      query: (body) => ({
        url: `/Payments/ChargeToken`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, arg) => [
        "Questionnaires",
        { type: "PaymentToken", id: arg.UsersId },
      ],
    }),
    updateQuestionnaireScoreTotalAmount: build.mutation<
      TUpdateQuestionnaireScoreTotalAmountResponse,
      { id: number; body: TUpdateQuestionnaireScoreTotalAmountRequest }
    >({
      query: ({ id, body }) => ({
        url: `/Companies/UpdateQuestionnaireScoreTotalAmount/${id}`,
        method: "PUT",
        body,
      }),
      //invalidatesTags: ["PaymentToken"],
    }),
    getPaymentTypes: build.query<TPaymentTypesResponse, void>({
      query: () => ({
        url: `/AdminTech/Admin_PaymentTypes_DML/1`,
        method: "POST",
        body: {
          Id: 0,
          Name: "",
          StatusId: 1,
        },
      }),
    }),
    getActiveQuestionnaireScoreStatuses: build.query<TQuestionnaireScoreStatusesResponse, void>({
      query: () => ({
        url: `/Companies/GetActiveQuestionnaireScoreStatuses`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useCheckUserPaymentTokenQuery,
  useLazyCheckUserPaymentTokenQuery,
  useGetTherapistServicesWithPricesQuery,
  useLazyGetTherapistServicesWithPricesQuery,
  useChargeTokenMutation,
  useUpdateQuestionnaireScoreTotalAmountMutation,
  useGetPaymentTypesQuery,
  useGetActiveQuestionnaireScoreStatusesQuery
} = paymentsApi;

